export const normalizePythonModule = (libraryName: string): string => libraryName.toLowerCase().replace(/[.-]/g, '_')
